export const modalReservationDirect = {
  header: {
    title: "Direct web bookings",
    subtitle: "Set what the guest sees and how rules apply.",
  },
  tabs: {
    reservations: "Booking status",
    ratePlans: "Rates",
    promotions: "Promotions",
    addons: "Additional charges",
    payments: "Prices & Payments",
    share: "Share",
  },
  common: {
    close: "Close",
    updating: "Updating…",
    hotel: "Hotel",
    apartment: "Apartment",
    visible: "Visible",
    default: "Default",
    dragToReorder: "Drag to reorder",
    saving: "Saving…",
    preview: "Preview",
  },
  toast: {
    successTitle: "Success",
  },
  save: {
    ratePlans: "Save rates",
    promotions: "Save promotions",
    addons: "Save charges",
    default: "Save",
  },
  reservations: {
    cardTitle: "Direct booking status",
    cardDesc: "Turn direct booking availability on or off (globally and per unit).",
    activateTitle: "Enable direct bookings",
    activateHelp: "If this is off, you can't enable individual units.",
    colName: "Accommodation / Unit",
    colCapacity: "Capacity",
    colAvailable: "Available",
    emptyUnits: "No units configured for this property.",
  },
  ratePlans: {
    title: "Rates shown in Direct Booking",
    hotelDesc: "Set which rates are shown for each room type",
    apartmentDesc: "Choose which rate plans the guest sees, which is the default and the order",
    loading: "Loading rates…",
    emptyApartment: "No rates configured for this property.",
    emptyHotel: "No room types configured for this hotel.",
    emptyRoom: "No rates configured for this room.",
    colTarifa: "Rate",
    colVisibleName: "Display name",
    visibleNameTooltip: "Optional name to show the guest",
    namePlaceholderApartment: "e.g. Non-refundable / Flexible",
    namePlaceholderHotel: "e.g. Breakfast included",
    derivedBadge: "Derived",
    rulesApartment: "Rules: at least 1 visible and 1 default (which must be visible).",
    rulesHotel: "Each room must have at least 1 visible rate and 1 default.",
  },
  rooms: {
    ratesCount: "{count} rate | {count} rates",
    meta: "Capacity: {capacity} • Adults: {adults} • Children: {children}",
  },
  promotions: {
    title: "Promotions in Direct Booking",
    desc: "Control which ones are shown, whether they apply automatically and the order.",
    loading: "Loading promotions…",
    empty: "No promotions configured for this property.",
    colPromo: "Promotion",
    colBadge: "Badge",
    badgeTooltip: "Short text (e.g. -10%, Deal, Early Bird).",
    colAuto: "Auto-apply",
    colStackable: "Stackable",
    badgePlaceholder: "e.g. -10% / Deal",
    tip: "Tip: if you don't want a promo to affect the final price, turn off “Auto-apply” and keep it visible.",
    fromDate: "From {date}",
    untilDate: "Until {date}",
  },
  addons: {
    loading: "Loading settings…",
    subtabOccupancy: "Occupancy discount",
    subtabExtraGuest: "Extra guest charge",
    baseOccupancyTitle: "Base occupancy",
    baseOccupancyDesc: "The usual price matches this occupancy. For fewer guests you apply a reduction.",
    guestsLabel: "guests",
    headOccupancy: "Occupancy",
    headRule: "Rule",
    headValue: "Value",
    headActive: "Active",
    guestWord: "guest | guests",
    usualPrice: "Usual price",
    modePercent: "Reduction %",
    modeFixed: "Fixed reduction (per night)",
    occupancyExample: "Example: base 4 guests and discounts for 3, 2 and 1.",
    configTitle: "Settings",
    configDesc: "Apply a surcharge for each extra guest above the included occupancy.",
    activate: "Enable",
    includedTitle: "Included occupancy",
    includedDesc: "Taken automatically from the accommodation capacity.",
    maxExtraLabel: "Maximum extra guests allowed",
    maxHelpHtml: "How many guests can be added <b>on top of the included occupancy</b>.<br />If you set <b>0</b>, no extra guests are allowed.<br />If you leave it empty, there is no limit.",
    chargeTypeLabel: "Charge type",
    chargeTypeFixed: "Fixed amount",
    chargeTypePercentage: "Percentage",
    chargeTypeHelp: "Fixed: {currency} per extra guest. Percentage: % of the base price.",
    priceLabel: "Price per additional guest",
    appliesHelp: "Applied per additional guest.",
    appliesBlockedNote: "(No extra guests allowed when the maximum is 0)",
    applicationLabel: "Application",
    applicationNote: "For now this charge applies per night.",
    previewFixed: "Each additional guest adds <b>{amount}</b> per night.",
    previewPercent: "Each additional guest adds <b>{percent}%</b> of the base price per night.",
    singleValueNote: "This is a <b>single value</b> (e.g. +10 {currency} or +15% per extra guest).",
  },
  payments: {
    title: "Prices & Payments",
    desc: "Charge type and discounts for direct bookings.",
    paymentTypeTitle: "Payment type",
    onArrivalLabel: "Pay on arrival",
    onArrivalDesc: "The guest books and pays directly on arrival.",
    onlineLabel: "Online payment",
    onlineDesc: "The guest pays online when completing the booking.",
    discountsTitle: "Discounts",
    enableDiscount: "Enable discount on direct bookings",
    discountTypeTitle: "Discount type",
    typePercentage: "Percentage",
    typePercentageDesc: "Discount proportional to the total.",
    typeFixed: "Fixed",
    typeFixedDesc: "Fixed amount to deduct.",
    valueTitle: "Value",
    placeholderPercentage: "e.g. 10",
    placeholderFixed: "e.g. 15.00",
    helpPercentage: "Maximum 100%. Applied to the total.",
    helpFixed: "A fixed amount is deducted in {currency}.",
    previewPercentage: "A {percent}% discount will be applied.",
    previewFixed: "A discount of {amount} will be applied.",
  },
  share: {
    title: "Share",
    desc: "Copy the direct booking link and share it on WhatsApp or open the guest view.",
    linkLabel: "Booking link",
    linkHelp: "This is the link you share with guests.",
    viewAsGuest: "View as guest",
    tip: "Tip: share this link in your bio, automatic messages and campaigns.",
    whatsappMessage: "Hi 👋 Here's the link to book: {link}",
  },
  errors: {
    loadRatePlans: "Could not load the rates.",
    saveRatePlans: "Could not save the rates.",
    roomMinVisible: 'Room "{name}" must have at least 1 visible rate.',
    roomExactlyOneDefault: 'Room "{name}" must have exactly 1 default rate.',
    roomDefaultMustBeVisible: 'In "{name}", the default rate must be visible.',
    aptMinVisible: "You must keep at least 1 visible rate.",
    aptExactlyOneDefault: "There must be exactly 1 default rate.",
    aptDefaultMustBeVisible: "The default rate must be visible.",
    loadPromotions: "Could not load the promotions.",
    savePromotions: "Could not save the promotions.",
    saveAddons: "Could not save the additional charges.",
    maxExtraRange: "The maximum extra guests must be between 0 and 50 (or empty = no limit).",
    extraPriceInvalid: "The price per additional guest must be valid (>= 0).",
    percentRange: "The percentage must be between 0 and 100.",
    baseOccupancyRange: "The base occupancy must be between 1 and {max}.",
    discountValuesInvalid: "Discount values must be valid numbers (>= 0).",
    discountPercentMax: "Percentage discounts cannot exceed 100.",
    updateFailed: "Could not update.",
    updateUnitFailed: "Could not update the unit status.",
    updateGlobalFailed: "Could not update the global status.",
    noLinkCopy: "No link to copy.",
    copyFailed: "Could not copy the link.",
    noLinkShare: "No link to share.",
    noLinkOpen: "No link to open.",
    updatePaymentType: "Could not update the payment type.",
    savePayments: "Could not save the changes.",
  },
  success: {
    ratePlansSaved: "Rates saved successfully.",
    promotionsSaved: "Promotions saved successfully.",
    addonsSaved: "Additional charges saved successfully.",
    updated: "Updated successfully.",
    globalUpdated: "Global status updated.",
    linkCopied: "Link copied.",
    changesSaved: "Changes saved.",
  },
};
